import { useSelector } from "react-redux"
import CalculatedStaffPercent from "./CalculatedStaffPercent"
import CalculatedStaffPrize from "./CalculatedStaffPrize"

function StaffPercent(){
    const HoursStaffKashierArray = useSelector(state => state.StaffSlice.HoursStaffKashierArray);
    const HoursStaffCookArray = useSelector(state => state.StaffSlice.HoursStaffCookArray);
    const HoursStaffCookSecondGroupArray = useSelector(state => state.StaffSlice.HoursStaffCookSecondGroupArray);

    const Period = useSelector(state => state.PeriodSlice.Period)

    const RevenueArray = useSelector(state => state.RevenueSlice.RevenueArray)
    const PercentCity = useSelector(state => state.RevenueSlice.PercentCity)

    return(
        <div>
            <div
            className="StaffPercentMainDiv Margin"
            >
                {Period.MinDay < 14 && 
                <div
                className="RevenueCityLongDiv"
                >
                    Касиры часов
                </div>
                }
            
                
                {HoursStaffKashierArray.length > 0 && HoursStaffKashierArray.map((el, index) => 
                index < 15 && index > Period.MinDay && index < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {String(el).replace('.', ',')}
                    </div>
                )}


                {Period.MinDay < 14 && 
                <div
                className="PercentStaffMounthPartBetweenDiv"
                >
                </div>
                }

                {Period.MaxDay > 15 && HoursStaffKashierArray.length > 0 && 
                <div
                className="RevenueCityLongDiv"
                >
                    Касиры часов
                </div>
                }

                {HoursStaffKashierArray.length > 0 && HoursStaffKashierArray.map((el, index) => 
                index > 14 && index > Period.MinDay && index < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {String(el).replace('.', ',')}
                    </div>
                )}
                
                
            </div>
            <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                    Повара (группа 1) часов
                </div>
                }
            
                
                {HoursStaffCookArray.length > 0 && HoursStaffCookArray.map((el, index) => 
                index < 15 && index > Period.MinDay && index < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {String(el).replace('.', ',')}
                    </div>
                )}                        

                {Period.MinDay < 14 &&
                <div
                className="PercentStaffMounthPartBetweenDiv"
                >
                </div>
                }

                {Period.MaxDay > 15 && HoursStaffCookArray.length > 0 &&
                <div
                className="RevenueCityLongDiv"
                >
                    Повара (группа 1) часов
                </div>
                }

                {HoursStaffCookArray.length > 0 && HoursStaffCookArray.map((el, index) => 
                index > 14 && index > Period.MinDay && index < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {String(el).replace('.', ',')}
                    </div>
                )}  
                
                
            </div>

            <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                    Повара (группа 2) часов
                </div>
                }
            
                
                {HoursStaffCookSecondGroupArray.length > 0 && HoursStaffCookSecondGroupArray.map((el, index) => 
                index < 15 && index > Period.MinDay && index < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {String(el).replace('.', ',')}
                    </div>
                )}                        

                {Period.MinDay < 14 &&
                <div
                className="PercentStaffMounthPartBetweenDiv"
                >
                </div>
                }

                {Period.MaxDay > 15 && HoursStaffCookSecondGroupArray.length > 0 &&
                <div
                className="RevenueCityLongDiv"
                >
                    Повара (группа 2) часов
                </div>
                }

                {HoursStaffCookSecondGroupArray.length > 0 && HoursStaffCookSecondGroupArray.map((el, index) => 
                index > 14 && index > Period.MinDay && index < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {String(el).replace('.', ',')}
                    </div>
                )}  
                
                
            </div>
            
            <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                    {'Сумма % на кассиров'}
                </div>
                }
            
                
                {RevenueArray.length > 0 && RevenueArray.map((el, index) => 
                index < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))).toFixed(2).replace('.', ',')}
                    </div>
                )}

                {Period.MinDay < 14 &&
                <div
                className="PercentStaffMounthPartBetweenDiv"
                >
                </div>
                }

                {Period.MaxDay > 15 &&
                <div
                className="RevenueCityLongDiv"
                >
                    {'Сумма % на кассиров'}
                </div>
                }
                        
                {RevenueArray.length > 0 && RevenueArray.map((el, index) => 
                index > 14 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))).toFixed(2).replace('.', ',')}
                    </div>
                )}
                

            </div>

            <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                    {'Сумма % на поваров (группа 1)'}
                </div>
                }
            
                
                {RevenueArray.length > 0 && RevenueArray.map((el, index) => 
                index < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))).toFixed(2).replace('.', ',')}
                    </div>
                )}
                       
                        
                {Period.MinDay < 14 &&
                <div
                className="PercentStaffMounthPartBetweenDiv"
                >
                </div>
                }

                {Period.MaxDay > 15 &&
                <div
                className="RevenueCityLongDiv"
                >
                    {'Сумма % на поваров (группа 1)'}
                </div>
                }
                        
                {RevenueArray.length > 0 && RevenueArray.map((el, index) => 
                index > 14 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))).toFixed(2).replace('.', ',')}
                    </div>
                )}

            </div>

            <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                    {'Сумма % на поваров (группа 2)'}
                </div>
                }
            
                
                {RevenueArray.length > 0 && RevenueArray.map((el, index) => 
                index < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))).toFixed(2).replace('.', ',')}
                    </div>
                )}
                       
                        
                {Period.MinDay < 14 &&
                <div
                className="PercentStaffMounthPartBetweenDiv"
                >
                </div>
                }

                {Period.MaxDay > 15 &&
                <div
                className="RevenueCityLongDiv"
                >
                    {'Сумма % на поваров (группа 2)'}
                </div>
                }
                        
                {RevenueArray.length > 0 && RevenueArray.map((el, index) => 
                index > 14 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))).toFixed(2).replace('.', ',')}
                    </div>
                )}

            </div>

            <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                    {'В час на кассиров'}
                </div>
                }
            
                
                {RevenueArray.length > 0 && RevenueArray.map((el, index) => 
                index < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {HoursStaffKashierArray[index] > 0 && PercentCity.Kashier > 0 ? parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[index]).toFixed(2).replace('.', ','): 0}
                    </div>
                )}
                        
                {Period.MinDay < 14 &&
                <div
                className="PercentStaffMounthPartBetweenDiv"
                >
                </div>
                }

                {Period.MaxDay > 15 &&
                <div
                className="RevenueCityLongDiv"
                >
                    {'В час на кассиров'}
                </div>
                }

                {RevenueArray.length > 0 && RevenueArray.map((el, index) => 
                index > 14 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {HoursStaffKashierArray[index] > 0 && PercentCity.Kashier > 0 ? parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[index]).toFixed(2).replace('.', ','): 0}
                    </div>
                )}
                     

            </div>

            <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                    {'В час на поваров (группа 1)'}
                </div>
                }
            
                
                {RevenueArray.length > 0 && RevenueArray.map((el, index) => 
                index < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {HoursStaffCookArray[index] > 0 && PercentCity.Cook > 0 ? parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[index]).toFixed(2).replace('.', ',') : 0}
                    </div>
                )}
                        
                {Period.MinDay < 14 &&
                <div
                className="PercentStaffMounthPartBetweenDiv"
                >
                </div>
                }

                {Period.MaxDay > 15 &&
                <div
                className="RevenueCityLongDiv"
                >
                    {'В час на поваров (группа 1)'}
                </div>
                }

                {RevenueArray.length > 0 && RevenueArray.map((el, index) => 
                index > 14 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {HoursStaffCookArray[index] > 0 && PercentCity.Cook > 0 ? parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[index]).toFixed(2).replace('.', ',') : 0}
                    </div>
                )}
            </div>

            <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                    {'В час на поваров (группа 2)'}
                </div>
                }
            
                
                {RevenueArray.length > 0 && RevenueArray.map((el, index) => 
                index < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {HoursStaffCookSecondGroupArray[index] > 0 && PercentCity.CookSecondGroup > 0 ? parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[index]).toFixed(2).replace('.', ',') : 0}
                    </div>
                )}
                        
                {Period.MinDay < 14 &&
                <div
                className="PercentStaffMounthPartBetweenDiv"
                >
                </div>
                }

                {Period.MaxDay > 15 &&
                <div
                className="RevenueCityLongDiv"
                >
                    {'В час на поваров (группа 2)'}
                </div>
                }

                {RevenueArray.length > 0 && RevenueArray.map((el, index) => 
                index > 14 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={index}
                    className="DateDivRevenue"
                    >
                    {HoursStaffCookSecondGroupArray[index] > 0 && PercentCity.CookSecondGroup > 0 ? parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[index]).toFixed(2).replace('.', ',') : 0}
                    </div>
                )}
            </div>

            <CalculatedStaffPercent/>
            <CalculatedStaffPrize/>
            
        </div>
    )
}

export default StaffPercent